export enum UtmSource {
  Multiposting = 'multiposting',
  JobsoraPflegia = 'jobsoraPflegia',
}
